<template>
    <b-modal ref="profile_modal"
             size="lg"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">{{ __t('REVIEW') }} №{{ this.item.id }}</span>
                    <span class="badge rounded-pill bg-primary-50 color-primary-500 ml-2" v-if="item.status">
                        {{ __t('NEW') }}
                    </span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.item.title}}
                                <small class="text-muted mb-0">
                                    {{__t('org_info')}}
                                </small>
                            </h5>
                        </div>

                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
                                       :disabled="tab.disabled"
                                       :title="get_tab_title(tab)"
                                       :key="index"
                                       :active="tab.is_active"
                                >
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>

                                    <component v-bind:is="tab.index" :org="item"></component>
                                </b-tab>
                            </b-tabs>
                        </div>
                        <div>
                        </div>
                    </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import review_tab_info from "./tabs/review_tab_info.vue";
import review_tab_files from "./tabs/review_tab_files.vue";

export default {
    name: "catalog_review_modal",
    components : {
        review_tab_info,
        review_tab_files

    },
    props : {
        modal_position : {
            type : String,
            default : "right"
        },
    },
    data() {
        return {
            item_id : 0,
            item: {
                "id" : 0,
                "title" : "",
                "uniq_id" : ""
            },
            is_load: false,
            is_show_modal: false,
            tabs : []
        }
    },

    created () {
        EventBus.$on("review_show",res => this.work_click(res));
        EventBus.$on("review_close",this.close);
    },

    methods : {
        work_click(item_id) {
            this.item_id = item_id;
            this.is_show_modal = true;

            this.load_review();
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },

        close () {
            this.item = {
                id : 0,
                title : "",
                uniq_id : "",
            };

            this.tabs = [];
            this.is_show_modal = false;
        },

        async load_review () {
            this.is_load = true;
            this.tabs = [];

            await review_api.get('/reviews/' + parseInt(this.item_id)).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.item = data.data;
                    this.push_tabs();
                    this.load_source_has_reply();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });
        },

        load_source_has_reply () {
            if (!this.item.source || !this.item.source.id) return;

            review_api.get('/reviews/sources/' + this.item.source.id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.$set(this.item, 'has_reply', !!data.data.has_reply);
                }
            }).catch(() => {
            });
        },

        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: false,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },

    },
    computed : {
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },

        default_tabs() {
            return [
                {
                    "title": this.__t('MAIN_INFO'),
                    "index": "review_tab_info",
                    is_active:false,
                },
                {
                    "title": this.__t('FILES'),
                    "index": "review_tab_files",
                    is_active:false,
                }
            ]
        },
    }
}
</script>

<style scoped>

</style>
